import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BootScreenContainer = styled.div`
  background-color: #000;
  color:rgb(255, 255, 255);
  font-family: 'Courier New', monospace;
  height: 100vh;
  width: 100vw;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  text-align: left;
`;

const Pre = styled.pre`
  margin: 0;
  white-space: pre;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
`;

const Tagline = styled.div`
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 16px;
`;

const MessageContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const ascii = `
    ____              _     _  ____   _____ 
   |  _ \\  __ ___   _(_) __| |/ __ \\ / ____|
   | | | |/ _\` \\ \\ / / |/ _\` | |  | | (___  
   | |_| | (_| |\\ V /| | (_| | |__| |\\___ \\ 
   |____/ \\__,_| \\_/ |_|\\__,_|\\____/ ____/
`;

const bootMessages = [
  "Initializing DavidOS kernel...",
  "Checking hardware compatibility...",
  "Any second now...",
  "okay last one i promise...",
  "Initializing DavidOS_Miner.exe...;)",
];

const loadingFrames = [
  "[    ]",
  "[=   ]",
  "[==  ]",
  "[=== ]",
  "[====]",
  "[ ===]",
  "[  ==]",
  "[   =]"
];

export const BootScreen = ({ onBootComplete }) => {
  const [currentMessage, setCurrentMessage] = useState(0);
  const [frame, setFrame] = useState(0);
  const [showCursor, setShowCursor] = useState(true);
  const [completedMessages, setCompletedMessages] = useState([]);

  useEffect(() => {
    // Animate loading bar
    const loadingInterval = setInterval(() => {
      setFrame(prev => (prev + 1) % loadingFrames.length);
    }, 100);

    // Blink cursor
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);

    // Add messages one by one
    const messageInterval = setInterval(() => {
      if (currentMessage < bootMessages.length) {
        setCompletedMessages(prev => [...prev, bootMessages[currentMessage]]);
        setCurrentMessage(prev => prev + 1);
      } else {
        setTimeout(() => {
          onBootComplete();
        }, 1000);
      }
    }, 800);

    return () => {
      clearInterval(loadingInterval);
      clearInterval(cursorInterval);
      clearInterval(messageInterval);
    };
  }, [currentMessage, onBootComplete]);

  return (
    <BootScreenContainer>
      <ContentWrapper>
        <Pre>{ascii}</Pre>
        <Tagline>The Operating System You've Been Waiting For</Tagline>
        <MessageContainer>
          {completedMessages.map((msg, i) => (
            <div key={i}>
              {msg} {loadingFrames[7]} [OK]
            </div>
          ))}
          {currentMessage < bootMessages.length && (
            <div>
              {bootMessages[currentMessage]} {loadingFrames[frame]}
              {showCursor ? '_' : ' '}
            </div>
          )}
        </MessageContainer>
      </ContentWrapper>
    </BootScreenContainer>
  );
};

export default BootScreen; 